/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box, Radio, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import type { ToolbarSelectionRadiosProps } from './types';

export function ToolbarConfigRadios<Key>( { items, value, isDisabled, onChange }: ToolbarSelectionRadiosProps<Key> ): ReactNode {
	return (
		<Stack gap={ '4px' } paddingTop={ '8px' }>
			{ items.map( ( item: any ) => (
				<Box
					sx={ { display: 'flex', alignItems: 'center', gap: '5px', paddingLeft: '10px', opacity: isDisabled ? 0.5 : 1 } }
					key={ `toolbar-selection-${ item.key }` }
				>
					<Radio
						disabled={ isDisabled }
						checked={ value === item.key }
						value={ item.key }
						id={ 'toolbar-radio-' + item.key }
						onChange={ e => onChange( e.target.value as Key ) }
					/>
					<Typography
						htmlFor={ 'toolbar-radio-' + item.key }
						component="label"
						fontSize={ '12px' }
						lineHeight={ '20px' }
						fontWeight={ 500 }
						color={ 'text.primary' }
					>
						{ item.label }
					</Typography>
				</Box>
			) ) }
		</Stack>
	);
}
